import Home from "../views/Home.vue";
import ServiceInit from "../views/authservice/ServiceInit.vue";
import ServiceIntro from "../views/authservice/ServiceIntro.vue";
import WarrantyPeriod from "../views/authservice/WarrantyPeriod.vue";
import CreateAuthcode from "../views/authservice/CreateAuthcode.vue";
import ManageAuthcode from "../views/authservice/ManageAuthcode.vue";
import ManageAuthMembers from "../views/authservice/ManageAuthMembers.vue";
import LostRecord from "../views/authservice/LostRecord.vue";
import Printqr from "../views/authservice/Printqr.vue";
import Setting from "../views/authservice/Setting.vue";
import Payment from "../views/authservice/Payment.vue";
import AdditionalService from "../views/authservice/AdditionalService.vue";

export const CAFE24_ROUTES = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/authservice/init",
    name: "ServiceInit",
    component: ServiceInit,
  },
  {
    path: "/authservice/:mall_id/serviceIntro",
    name: "ServiceIntro",
    component: ServiceIntro,
    props: true,
  },
  {
    path: "/authservice/:mall_id/warrantyPeriod",
    name: "WarrantyPeriod",
    component: WarrantyPeriod,
    props: true,
    meta: {
      requireModes: ["basic", "plus"],
    },
  },
  {
    path: "/authservice/:mall_id/createAuthcode",
    name: "CreateAuthcode",
    component: CreateAuthcode,
    props: true,
    meta: {
      requireModes: ["basic", "plus"],
    },
  },
  {
    path: "/authservice/:mall_id/manageAuthcode",
    name: "ManageAuthcode",
    component: ManageAuthcode,
    props: true,
    meta: {
      requireModes: ["basic", "plus"],
    },
  },
  {
    path: "/authservice/:mall_id/manageAuthMembers",
    name: "ManageAuthMembers",
    component: ManageAuthMembers,
    props: true,
    meta: {
      requireModes: ["plus"],
    },
  },
  {
    path: "/authservice/:mall_id/lostRecord",
    name: "LostRecord",
    component: LostRecord,
    props: true,
    meta: {
      requireModes: ["plus"],
    },
  },
  {
    path: "/authservice/:mall_id/printqr",
    name: "Printqr",
    component: Printqr,
    props: true,
    meta: {
      requireModes: ["plus"],
    },
  },
  {
    path: "/authservice/:mall_id/setting",
    name: "Setting",
    component: Setting,
    props: true,
    meta: {
      requireModes: ["basic", "plus"],
    },
  },
  {
    path: "/authservice/:mall_id/payment",
    name: "Payment",
    component: Payment,
    props: true,
  },
  {
    path: "/authservice/:mall_id/additionalService",
    name: "AdditionalService",
    component: AdditionalService,
    props: true,
  },
];
